const formrules = {
  requiredSelected: (value) => !!value || 'Preenchimento obrigatório.',
  required: (value) => !!value && (value && value.trim().length !== 0) || 'Preenchimento obrigatório.',
  phone: (value) => !value || (value && (value.length === 14 || value.length === 15)) || 'Formato inválido.',
  cnpj: (value) => {
    const messageInvalidCNPJ = 'Formato inválido.';
    
    if (value && value.length === 18) {
      const cnpjClean = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      if (cnpjClean.length !== 14 || !/^[A-Z0-9]{12}\d{2}$/.test(cnpjClean)) return messageInvalidCNPJ;
      
      if (cnpjClean === '00000000000000' || cnpjClean === '11111111111111'            
        || cnpjClean === '22222222222222' || cnpjClean === '33333333333333'            
        || cnpjClean === '44444444444444' || cnpjClean === '55555555555555'            
        || cnpjClean === '66666666666666' || cnpjClean === '77777777777777'            
        || cnpjClean === '88888888888888' || cnpjClean === '99999999999999') {
        return messageInvalidCNPJ;
      }
      
      const calcDigit = (cnpj, position) => {
        let sum = 0;
        let current = position === 12
          ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
          : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

        for (let i = 0; i < position; i++) {
          const val = cnpj.codePointAt(i) - 48;
          sum += val * current[i];
        }

        const rest = sum % 11;
        return rest < 2 ? 0 : 11 - rest;
      }

      const firstDigit = calcDigit(cnpjClean, 12);
      if (firstDigit !== parseInt(cnpjClean.charAt(12), 10)) {
        return messageInvalidCNPJ;
      }

      const secondDigit = calcDigit(cnpjClean, 13);
      if (secondDigit !== parseInt(cnpjClean.charAt(13), 10)) {
        return messageInvalidCNPJ;
      }
      
      return true;
    }
    return messageInvalidCNPJ;
  },
  cnpjNotRequired: (value) => (!value || (value && value.length === 18)) || 'Formato inválido.',
  cpfCnpj: (value) => (value && (value.length === 14 || value.length === 18)) || 'Formato inválido.',
  cep: (value) => (value && value.length === 9) || 'Formato inválido.',
  email: (value) => {
    if (value && value.length > 0) {
      const pattern = /^(([^<>(){}!#$%^=+*[\]\\.,;:\s@"]+(\.[^<>(){}!#$%^=+*[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || 'Formato inválido.';
    }
    return true;
  },
}

export {
  formrules
}
